import React from "react";
import "./styles.css";
import Weathersearch from "./Weathersearch.js";
import Footer from "./Footer";


export default function App() {
  
  return (
    <div className="Weather">
      <div className="container">
        <div className="card">
          <div className="card-boby">
            <Weathersearch  cityName="Herne Bay"/>            
            </div>           
          </div>
          <Footer />
        </div>   
     </div>        
  );
}
